import {
  GET_SETTINGS,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_FAILURE,
  EDIT_SETTINGS,
  EDIT_SETTINGS_SUCCESS,
  EDIT_SETTINGS_FAILURE,
} from "./actionTypes";

const initialState = {
  settings: {},
  isLoggedIn: null,
  loading: false,
  error: "",
};

const settings = (state = initialState, action) => {
  switch (action.type) {
    case GET_SETTINGS:
      return { ...state, loading: true, error: "" };

    case GET_SETTINGS_SUCCESS:
      return { ...state, settings: action.payload?.[0], loading: false };

    case GET_SETTINGS_FAILURE:
      return { ...state, error: action.payload, loading: false };

    // ===================================================
    // ===================================================

    case EDIT_SETTINGS:
      return { ...state, loading: true, error: "" };

    case EDIT_SETTINGS_SUCCESS:
      return { ...state, settings: action.payload, loading: false };

    case EDIT_SETTINGS_FAILURE:
      return { ...state, error: action.payload, loading: false };

    // ===================================================
    // ===================================================

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default settings;
